export const GET_HEADER_LINKS = "GET_HEADER_LINKS";
export const GET_HEADER_LINKS_LOADING = "GET_HEADER_LINKS_LOADING";
